<template>
  <div>
    
    <input v-model="email" type="email" placeholder="输入支付时的邮箱地址" />
    <button @click="search">查询</button>


    <ul v-if="results.length > 0&& search_state==true" >
      <li v-for="(order, index) in results" :key="index">
        <strong>支付时间:</strong> {{ order.success_time }} <br />
        <strong>金额:</strong> {{ order.total_fee }} <br />
        <strong>CDKey:</strong> {{ order.cdkey }}
      </li>
    </ul>

    <p v-else-if="search_state==true">未查询到相关结果.</p>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProductSearch',
  data() {
    return {
      email: '',
      search_state: false,
      results: []
    };
  },
  methods: {
    async search() {
      if (!this.email) {
        alert('请输入邮箱地址.');
        return;
      }
      try {
        const response = await axios.get('/searchPay', {
          params: { email: this.email }
        });
        // 假设返回的数据结构是一个对象数组，其中每个对象有success_time、total_fee和cdkey字段
        console.log(response.data)
        if (response.data.error) {

          alert(response.data.error)
          return;
        }else{
          this.results = response.data.list;
          this.search_state=true;
        }
       
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  }
};
</script>

<style scoped>
input {
  margin-right: 10px;
}
button {
  margin-right: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
</style>